import { render, staticRenderFns } from "./multiline_input.vue?vue&type=template&id=bf96e394&scoped=true&"
import script from "./multiline_input.vue?vue&type=script&lang=ts&"
export * from "./multiline_input.vue?vue&type=script&lang=ts&"
import style0 from "./multiline_input.vue?vue&type=style&index=0&id=bf96e394&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf96e394",
  null
  
)

export default component.exports